import { memo } from 'react';
import { SxProps, Theme } from '@mui/material';
import { StyledPercentageInput, PercentageInputVariant } from './styles';
import usePercentageFormat from './usePercentageFormat';

interface PercentageInputProps {
  value: number | null;
  error?: boolean;
  label?: string;
  placeholder?: string;
  size?: 'small' | 'medium';
  disabled?: boolean;
  onChange?: (value: number | null) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  maxDecimals?: number;
  variant?: PercentageInputVariant;
  sx?: SxProps<Theme>;
  helperText?: string;
}

const PercentageInput = memo(
  ({
    value,
    error = false,
    label = '',
    placeholder = '',
    disabled = false,
    onChange,
    onFocus,
    onBlur,
    size = 'medium',
    maxDecimals = 2,
    variant = 'default',
    sx,
    helperText,
  }: PercentageInputProps) => {
    const { formattedValue, handleChange } = usePercentageFormat({
      value,
      maxDecimals,
      onChange,
    });

    return (
      <StyledPercentageInput
        type="text"
        size={size}
        label={label}
        placeholder={placeholder}
        value={formattedValue}
        onChange={handleChange}
        onFocus={onFocus}
        onBlur={onBlur}
        disabled={disabled}
        customVariant={variant}
        sx={sx}
        error={error}
        helperText={helperText}
      />
    );
  },
);

PercentageInput.displayName = 'PercentageInput';

export default PercentageInput;
